import { render, staticRenderFns } from "./text.vue?vue&type=template&id=de866454"
import script from "./text.ts?vue&type=script&lang=js&external"
export * from "./text.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports